import type { Icon } from '@phosphor-icons/react';
import {
  BookOpenIcon,
  BookOpenTextIcon,
  GameControllerIcon,
  HighlighterIcon,
  PencilSimpleIcon,
} from '@phosphor-icons/react';
import { ResourceKind } from './types';

export const RESOURCE_KIND_META: Record<ResourceKind, { title: string; Icon: Icon }> = {
  majorTests: { title: 'Tests majeurs', Icon: HighlighterIcon },
  minorTests: { title: 'Tests mineurs', Icon: PencilSimpleIcon },
  games: { title: 'Serious games', Icon: GameControllerIcon },
  books: { title: 'Ebooks majeurs', Icon: BookOpenIcon },
  ebooks: { title: 'Ebooks mineurs', Icon: BookOpenTextIcon },
};

export const RESOURCE_KIND_ORDER: ResourceKind[] = [
  'majorTests',
  'minorTests',
  'games',
  'books',
  'ebooks',
];
